<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
    <app-fonpen class="w-full" [defaultValue]="defaultData?.fonpen" (valueState)="setFonpen($event)" ></app-fonpen> 

    @for (item of dataInputs(); track $index) {
        <app-input class="w-full"
            [config]="item"
            (submitValue)="handleValue($event)">
        </app-input>
    }

    @for (item of dataSelected(); track $index) {
        <app-selected class="w-full"
            [config]="item"
            (selectValue)="handleValue($event)"
        ></app-selected>
    }

    <app-profession class="w-full" [defaultValue]="defaultData?.codpro" (valueState)="onProfessionSelected($event)"></app-profession>

</form>